import { gql } from '@apollo/client'

export const SYMPTOME_QUERY = gql`
  query Symptome($equipementId: bigint!) {
    symptomes: d4_symptometypeequipement(where: { typeequipement_id: { _eq: $equipementId } }) {
      id
      typeequipement_id
      symptome
    }
  }
`
